import React, {memo} from 'react';
import {Button, GooglePhotosIcon} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';
import PrivacyPolicyButton, {PrivacyPolicyButtonProps} from './PrivacyPolicyButton';

const Google = ({
  pending,
  privacyPolicyUrl,
  onClick,
}: {
  pending: boolean;
  onClick: (event: React.MouseEvent) => void;
} & PrivacyPolicyButtonProps) => {
  const {t} = useTranslation(['assetservices']);

  return (
    <>
      <Button
        onClick={onClick}
        label={!pending ? t('str_ButtonConnectToGoogle') : t('*:str_TitlePleaseWait')}
        buttonStyle={'distinct'}
        startIcon={<GooglePhotosIcon />}
        disabled={pending}
      />
      <PrivacyPolicyButton privacyPolicyUrl={privacyPolicyUrl} />
    </>
  );
};

export default memo(Google);
